import React from 'react';
import './add sharedProperty.css'
import { MDBContainer,  MDBRow, MDBCol,MDBBtn,MDBIcon} from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter,Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { message,TreeSelect,Progress } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import ResultDialog from "../../component/result/request"
const TreeNode = TreeSelect
const { SHOW_PARENT } = TreeSelect;

class AddSharedProperty extends React.Component {
    state = {
        type:'RELATED-TO-COMPOUND',
        priceType:'INSTALLMENT',
        sharePrice:0,
        price:0,
        downPayment:0,
        durationType:'MONTHLY',
        installmentDuration:0,
        monthlyInstallment:0,
        totalShares:0,
        availableShares:0,
        soldShares:0,
        projectName_ar:"",
        projectName_en:"",
        category:null,
        location:null,
        categories:[],
        locations:[],
        imgs:null,
        allImgs:null,
        imgsPreviewUrl:[],
        imgsName:[],
        imgsType:'data',
        voiceNote:null,
        voiceNoteType:"data",
        companyLogo:null,
        companyLogoType:'data',
        companyLogoName:'',
        employePhone:'',
        employeName:'',
        employeCountry:null,
        ratio:0,
        netRatio:0,
        minShares:1,
        progress:80,
        waitResponse:false,
        messageType:'success',
        showDialog:false,
        details:'',
        countries:[],
        finishingType:['FULLY-FINISHED'],
        deliveryStatus:['READY-To-MOVE'],
        pdf:null,
        pdfType:"data",
        pdfName:"",
    };

    constructor(props){
        super(props)
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }

    componentDidMount(){
        this.getCategory()
        this.getLocations()
        this.getCountries()
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }
    
    getCategory = () => {
        axios.get(`${BASE_END_POINT}categories`)
        .then(response=>{
          console.log(response.data)
          this.setState({categories:response.data.data})
        })
        .catch(error=>{
          console.log("ALL categories ERROR")
          console.log(error.response)
        })
    }
    getCountries = () => {
      axios.get(`${BASE_END_POINT}countries/withoutPagenation/get`,{
          headers: {
            'Content-Type': 'application/json',
            'Authorization':`Bearer ${this.props.currentUser.token}`
          },
         })
      .then(response=>{
        console.log("countries",response.data)
        this.setState({countries:response.data.data})
      })
      .catch(error=>{
        console.log("ALL countries ERROR")
        console.log(error.response)
      })
    }
    getLocations = () => {
    axios.get(`${BASE_END_POINT}location/withoutPagenation/get`)
    .then(response=>{
        console.log(response.data)
        this.setState({locations:response.data.data})
    })
    .catch(error=>{
        console.log("ALL locations ERROR")
        console.log(error.response)
    })
    }
    addSharedProperty = () => {
        
        const {finishingType,deliveryStatus,location,category,imgs,imgsType,totalShares,sharePrice,
            companyLogo,minShares, employePhone, employeName, employeCountry, ratio, netRatio,companyLogoType,
            pdf,pdfType,projectName_en,projectName_ar,price,priceType,durationType,installmentDuration,downPayment,voiceNote,voiceNoteType} = this.state
            
            if(category !==null && location !==null && companyLogo !== null &&imgs !==null ){
                this.setState({waitResponse:true})
                message.loading('Wait..', 1.5)
                var data = new FormData()
                data.append('type','RELATED-TO-COMPOUND')
                data.append('finishingType',JSON.stringify(finishingType))
                data.append('deliveryStatus',JSON.stringify(deliveryStatus))
                data.append('projectName_en',projectName_en)
                data.append('projectName_ar',projectName_ar)
                data.append('minShares',minShares)
                data.append('employePhone',employePhone)
                data.append('employeName',employeName)
                data.append('employeCountry',employeCountry)
                data.append('ratio',ratio)
                data.append('netRatio',netRatio)
                data.append('price',price !=0 ? price.replace(/,/g, ''):0)
                data.append('priceType',priceType)
                data.append('category',category)
                data.append('location',location)
                data.append('sharePrice',sharePrice !=0 ? sharePrice.replace(/,/g, ''):0)
                data.append('totalShares',totalShares)
                if(priceType === 'INSTALLMENT'){
                    data.append('downPayment', downPayment !=0 ? downPayment.replace(/,/g, ''):0)
                    data.append('durationType',durationType)
                    data.append('installmentDuration',installmentDuration)
                    data.append('monthlyInstallment', this.state.monthlyInstallment !=0 ? this.state.monthlyInstallment.replace(/,/g, ''):0)
                }
                
                if(imgs != null && imgsType){
                  for(var i=0 ; i<= imgs.length-1 ; i++){
                    data.append(`imgs`,imgs[i] )
                  } 
                }
                if (companyLogo != null && companyLogoType === "data") {
                    data.append(`companyLogo`, companyLogo)
                }
                if(pdf != null && pdfType ==="data"){
                    data.append(`pdf`,pdf )
                }
                if(voiceNote != null && voiceNoteType ==="data"){
                    data.append(`voiceNote`,voiceNote)
                }
                console.log(Array.from(data))

                axios.post(`${BASE_END_POINT}sharedProperties`,data,{
                    headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization':`Bearer ${this.props.currentUser.token}`,
                    'Accept-Language':this.props.isRTL?'ar':'en'
                    },
                })
                .then(response=>{
                    this.setState({
                        showDialog:true,messageType:'success',progress:100
                    })
                })
                .catch(error=>{
                    console.log(error.response)
                    if(error.response.data.errors){
                        this.setState({
                            showDialog:true,
                            messageType:'error',
                            details:error.response.data.errors.msg[0].msg
                        })
                    }else{
                        this.setState({showDialog:true,messageType:'error'})
                    }
                    this.setState({waitResponse:false,progress:50})
                })
            }
    }
    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
        this.addSharedProperty()
    };
    changeHandler = event => {
        const { name, value } = event.target;

        if (name === "price" || name === "downPayment" || name === "monthlyInstallment" || name === "sharePrice") {
            // Remove all characters except digits and dots
            let cleaned = value.replace(/[^0-9.]/g, '');

            // Allow only the first dot for decimal
            const firstDotIndex = cleaned.indexOf('.');
            if (firstDotIndex !== -1) {
                // Split at the first dot
                const integerPart = cleaned.substring(0, firstDotIndex);
                const decimalPart = cleaned.substring(firstDotIndex + 1).replace(/\./g, ''); // remove other dots

                // Add commas to the integer part
                const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

                event.target.value = `${formattedInteger}.${decimalPart}`;
            } else {
                // No dot, just format as integer
                event.target.value = cleaned.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
        }

        this.setState({ [name]: event.target.value });
    };

    fileChangedHandlerImgs = (event) => {
        let imgs =[];
        let imgsPreviewUrl = [];
        let imgsName = []
    

        for(var i=0 ; i<= event.target.files.length-1 ; i++){
            imgsPreviewUrl.push(URL.createObjectURL(event.target.files[i]))
            imgsName.push(event.target.files[i].name)
        }
        imgs.push(event.target.files)
        this.setState({
            imgs: event.target.files,
            imgsType:'data',
            imgsPreviewUrl:imgsPreviewUrl,
            imgsName:imgsName
        });
    
    };
    removeFileImgs = (url) => {
        console.log(url);
        let arr = this.state.imgsPreviewUrl;
        let arr2 =  Array.from(this.state.imgs);

        var index = arr.indexOf(url);
        if (index !== -1) arr.splice(index, 1);
        if (index !== -1) arr2.splice(index, 1);
        this.setState({
            imgsPreviewUrl: arr,
            imgs:arr2,
        });
        if(arr2.length === 0){
            this.setState({
            imgs:null,
            imgsName:[]
            });
        }

    };
    fileChangedHandlerVoiceNote = event => {
        console.log(event.target.files[0])
        this.setState({
          voiceNote: event.target.files[0],
          voiceNoteType:"data"
        })
        document.addEventListener("DOMContentLoaded", function() {
            document.getElementById('audioFileInput').addEventListener('change', function(event) {
              var file = event.target.files[0];
              var audioPlayer = document.getElementById('audioPlayer');
              var audioSource = document.getElementById('audioSource');
              if (file) {
                  audioSource.src = URL.createObjectURL(file);
                  audioPlayer.load();
              }
            });
        });
        
    }
    removeFileVoiceNote = () => {
        this.setState({
          voiceNote:null,
          voiceNoteType:"url"
        });
    }
    fileChangedHandlerCompanyLogo = event => {
        this.setState({
        companyLogo: event.target.files[0],
        companyLogoName: event.target.files[0].name,
        companyLogoType:"data"
        })
        
    }
    removeFileCompanyLogo = () => {
        this.setState({
            companyLogo:null,
            companyLogoName:'',
            companyLogoType:"url"
        });
    }
    fileChangedHandlerPdf = event => {
        this.setState({
          pdf: event.target.files[0],
          pdfType:"data",
          pdfName:event.target.files[0].name,
        })
        
    }
    removePdf = () => {
        this.setState({
            pdf:null,
            pdfName:'',
            pdfType:"url"
        });
    }
      
  
  render(){
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('PROPERTIES')) return <Redirect to='/Home' />

  return (
    <div className="App">
        <MDBContainer> 
            {this.state.showDialog &&
                <ResultDialog type={this.state.messageType} message={this.state.messageType ==="success"?allStrings.done:allStrings.error} details = {this.state.details}/>
            }
            <MDBRow>  
                <MDBCol md="12">
                    <div className="infoCard">
                        <Card className="editCard">
                        <CardMedia
                        style={{height:"0px"}}
                        />
                        <CardHeader></CardHeader>
                        <div  style={{flexDirection: this.props.isRTL?'row-reverse':'row',display: 'flex'}}>
                            <div className="topIcon" style={{background:'linear-gradient(135deg, #0F1A2C, #233B5B, #3A5278)',zIndex:9}}>
                                <span className="material-icons" style={{color:'white',fontSize:23}}>location_city</span>
                            </div>
                            <div className="tableTitle" style={{display:this.props.isRTL?'inline-block':'inline-block',marginTop:this.props.isRTL?'-60px':'-60px',
                            marginLeft:this.props.isRTL?'0':'0',marginRight:this.props.isRTL?'0':'0',position:'relative'}}>
                            <p>{allStrings.add}</p>
                            </div>
                        </div>
                        <CardContent style={{minHeight:"390px",outline:'none'}}>
                        <MDBContainer>
                            
                            <MDBRow>
                                <MDBCol md="12">
                                    <form
                                    className="needs-validation"
                                    onSubmit={this.submitHandler}
                                    noValidate
                                    >
                                        
                                        <div className="grey-text">
                                            {this.state.waitResponse&&
                                                <Progress percent={this.state.progress} status="active" showInfo={false} />
                                            }
                                            <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                        <label htmlFor="formn8" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.ratio}</label>
                                                        <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.ratio} type="number" min={0} id="formn8" className="form-control" name='ratio' onChange={this.changeHandler} required validate/>
                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                        <label htmlFor="formn8" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.netRatio}</label>
                                                        <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.netRatio} type="number" min={0} id="formn8" className="form-control" name='netRatio' onChange={this.changeHandler} required validate/>
                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            <MDBRow>
                                                <MDBCol md="6">
                                                <div className="md-form">
                                                    <label htmlFor="form33" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.totalShares}</label>
                                                    <input style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.totalShares} type="number" min={0} id="form33" name="totalShares" className="form-control" onChange={this.changeHandler} required validate />
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                </div>
                                                </MDBCol>
                                                <MDBCol md="6">
                                                <div className="md-form">
                                                    <label htmlFor="form34" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.minShares}</label>
                                                    <input style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.minShares} type="text" min={1} id="form34" name="minShares" className="form-control" onChange={this.changeHandler} required validate />
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                </div>
                                                </MDBCol>
                                            </MDBRow>
                                            <MDBRow>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                        <label htmlFor="form33" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.sharePrice}</label>
                                                        <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.sharePrice} type="text" min={0} id="form33" name="sharePrice" className="form-control" onChange={this.changeHandler} required validate/>
                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                        <label htmlFor="form34" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.price}</label>
                                                        <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.price} type="text" min={0} id="form34" name="price" className="form-control" onChange={this.changeHandler} required validate/>
                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            <MDBRow>
                                                <MDBCol md="6">
                                                    <div class="md-form">
                                                    <label for="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishProjectName}</label>
                                                    <input disabled={this.state.actionType==="VIEW"?true:false} onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9-,.@%$#*&()_^&!\\/\s-_]/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.projectName_en} type="text" id="form645" name="projectName_en" class="form-control" onChange={this.changeHandler} required  validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                                <MDBCol md="6">
                                                    <div class="md-form">
                                                    <label for="form56" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicProjectName}</label>
                                                    <input disabled={this.state.actionType==="VIEW"?true:false} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^\u0600-\u06FF0-9#.,@%$_^*()\/\\ _-]+/g, '')} style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.projectName_ar} type="text" id="form56" name="projectName_ar" class="form-control" onChange={this.changeHandler} required validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            <MDBRow  style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                                <MDBCol md="12">
                                                    <div className="md-form">
                                                        <label htmlFor="form3" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.employeName}</label>
                                                        <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.employeName} type="text" id="form3" name="employeName" className="form-control" onChange={this.changeHandler} required validate/>
                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                                <MDBCol md="6">
                                                    <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.country}</label>
                                                    <TreeSelect
                                                    value= {this.state.employeCountry}
                                                    showSearch={true} 
                                                    style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                    treeCheckable = {false}    
                                                    treeNodeFilterProp="title"                      
                                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                    placeholder={allStrings.country}
                                                    showCheckedStrategy= {SHOW_PARENT}
                                                    onChange={(value) => {
                                                        this.setState({employeCountry:value});
                                                        console.log(value)
                                                    }} 
                                                    
                                                    >
                                                        {this.state.countries.map(val=>(
                                                            <TreeNode value={val.id} title={this.props.isRTL?val.name_ar:val.name_en} key={val.id} />
                                                        ))}
                                                    </TreeSelect>
                                                </MDBCol>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                        <label htmlFor="form03" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.employePhone}</label>
                                                        <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.employePhone} type="text" id="form03" name="employePhone" className="form-control" onChange={this.changeHandler} required validate/>
                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            <MDBRow>
                                                <MDBCol md="6" sm="6">
                                                    <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.location}</label>
                                                    <TreeSelect virtual={false}
                                                        showSearch={true}
                                                        style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                        treeCheckable = {false}
                                                        treeNodeFilterProp="title"                      
                                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                        placeholder={allStrings.location}
                                                        value={this.state.location}
                                                        showCheckedStrategy= {SHOW_PARENT}
                                                        onChange={(value) => {
                                                        console.log(value)
                                                        this.setState({location:value});
                                                        }} 
                                                    
                                                    >
                                                        {this.state.locations.map(val=>(
                                                            <TreeNode value={val.id} title={this.props.isRTL?val.name_ar:val.name_en} key={val.id} />
                                                        ))}
                                                    </TreeSelect>
                                                </MDBCol>
                                                <MDBCol md="6" sm="6">
                                                    <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.category}</label>
                                                    <TreeSelect virtual={false}
                                                        showSearch={false} 
                                                        style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                        treeCheckable = {false}         
                                                        treeNodeFilterProp="title"                      
                                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                        placeholder={allStrings.category}
                                                        value={this.state.category}
                                                        showCheckedStrategy= {SHOW_PARENT}
                                                        onChange={(value) => {
                                                        console.log(value)
                                                        this.setState({category:value});
                                                        }} 
                                                    
                                                    >
                                                        {this.state.categories.map(val=>(
                                                            <TreeNode value={val.id} title={this.props.isRTL?val.categoryName_ar:val.categoryName_en} key={val.id} />
                                                        ))}
                                                    </TreeSelect>
                                                </MDBCol>
                                            </MDBRow>
                                            <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                                
                                                <MDBCol md="6" sm="6">
                                                    <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.deliveryStatus}</label>
                                                    <TreeSelect virtual={false}
                                                        showSearch={false} 
                                                        style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                        treeCheckable = {true}
                                                        treeNodeFilterProp="title"                      
                                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                        placeholder={allStrings.deliveryStatus}
                                                        value={this.state.deliveryStatus}
                                                        showCheckedStrategy= {SHOW_PARENT}
                                                        onChange={(value) => {
                                                        console.log(value)
                                                        this.setState({deliveryStatus:value});
                                                        }} 
                                                    
                                                    >
                                                        <TreeNode value="READY-To-MOVE" title={allStrings.readyToMove} key="READY-To-MOVE" />
                                                        <TreeNode value="AFTER-ONE-YEAR" title={allStrings.afterOneYears} key="AFTER-ONE-YEAR" />
                                                        <TreeNode value="AFTER-TWO-YEARS" title={allStrings.afterTwoYears} key="AFTER-TWO-YEARS" />
                                                        <TreeNode value="AFTER-THREE-YEARS" title={allStrings.afterThreeYears} key="AFTER-THREE-YEARS" />
                                                    
                                                    </TreeSelect>
                                                </MDBCol>
                                                <MDBCol md="6" sm="6">
                                                    <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.finishingType}</label>
                                                    <TreeSelect virtual={false}
                                                        showSearch={false} 
                                                        style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                        treeCheckable = {true}
                                                        treeNodeFilterProp="title"                      
                                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                        placeholder={allStrings.finishingType}
                                                        value={this.state.finishingType}
                                                        showCheckedStrategy= {SHOW_PARENT}
                                                        onChange={(value) => {
                                                        console.log(value)
                                                        this.setState({finishingType:value});
                                                        }} 
                                                    >
                                                        <TreeNode value="FULLY-FINISHED" title={allStrings.fullyFinished} key="FULLY-FINISHED" />
                                                        <TreeNode value="SEMI-FINISHED" title={allStrings.semiFinished} key="SEMI-FINISHED" />
                                                        <TreeNode value="CORE-SHELL" title={allStrings.coreShell} key="CORE-SHELL" />
                                                        
                                                    </TreeSelect>
                                                </MDBCol>
                                            </MDBRow>
                                            <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                                <MDBCol md="6">
                                                    <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.priceType}</label>
                                                    <TreeSelect virtual={false}
                                                        showSearch={false} 
                                                        style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                        treeCheckable = {false}
                                                        treeNodeFilterProp="title"                      
                                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                        placeholder={allStrings.priceType}
                                                        value={this.state.priceType}
                                                        showCheckedStrategy= {SHOW_PARENT}
                                                        onChange={(value) => {
                                                        console.log(value)
                                                        this.setState({priceType:value});
                                                        }} 
                                                    
                                                    >
                                                        <TreeNode value="INSTALLMENT" title={allStrings.installment} key="INSTALLMENT" />
                                                        <TreeNode value="CASH" title={allStrings.cash} key="CASH" />
                                                        
                                                    </TreeSelect>
                                                </MDBCol>
                                                {this.state.priceType ==="INSTALLMENT"&&
                                                    <MDBCol md="6">
                                                        <div className="md-form">
                                                        <label htmlFor="form34" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.monthlyInstallment}</label>
                                                        <input style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.monthlyInstallment.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} type="text" min={0} id="form34" name="monthlyInstallment" className="form-control" onChange={this.changeHandler} required validate />
                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                        </div>
                                                    </MDBCol>
                                                }
                                            </MDBRow>
                                            
                                            
                                            {this.state.priceType ==="INSTALLMENT"&&
                                            <MDBRow>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                        <label htmlFor="form323" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.downPayment}</label>
                                                        <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.downPayment} type="text" id="form323" name="downPayment" className="form-control" onChange={this.changeHandler} required validate/>
                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                                <MDBCol md="6">
                                                    <div className="md-form">
                                                        <label htmlFor="form324" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.installmentDuration}</label>
                                                        <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.installmentDuration} type="number" min={0} id="form324" name="installmentDuration" className="form-control" onChange={this.changeHandler} required validate/>
                                                        <div class="valid-feedback">{allStrings.correct}</div>
                                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                            }
                                            <MDBRow>
                                                <MDBCol md="12">
                                                    <label htmlFor="form8930" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.companyLogo}</label>
                
                                                    <div className="fileUpload2"> 
                                                        <input  key={this.state.companyLogo} type='file' className="upImgs2" onChange={this.fileChangedHandlerCompanyLogo} ></input>
                                                        <span className="uploadParent"><UploadOutlined style={{color: '#000',fontSize: '14px',position: 'relative',top: '-3px',marginRight: '2px'}}/><span className="uploadName">{allStrings.upload}</span></span>
                                                    </div>
                                                    <div className="preview">
                                                    {this.state.companyLogo&&
                                                    <div style={{display:"inline-block",width: '100%',border: '1px solid mediumaquamarine'}}>
                                                        <img crossorigin="anonymous"alt="" src={this.state.companyLogoType==="data"?URL.createObjectURL(this.state.companyLogo):this.state.companyLogo} className="previewImg2"/>
                                                        
                                                        <span className="imgName">{this.state.companyLogoName}</span>
                                                        <MDBIcon icon="trash" className="mr-2 removeImg3"
                                                        onClick={() => this.removeFileCompanyLogo()}  ></MDBIcon>
                                                    </div>
                                                    }
                                                    </div>
                                                </MDBCol>  
                                            </MDBRow>
                                            <MDBRow>
                                                <MDBCol md="12">
                                                <label for="form830" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.voiceNote}</label>
                                                <div className="fileUpload2"> 
                                                    <input  key={this.state.voiceNote} type='file' className="upImgs2" onChange={this.fileChangedHandlerVoiceNote} ></input>
                                                    <span className="uploadParent"><UploadOutlined style={{color: '#000',fontSize: '14px',position: 'relative',top: '-3px',marginRight: '2px'}}/><span className="uploadName">{allStrings.uploadFile}</span></span>
                                                </div>
                                                {this.state.voiceNote != null &&
                                                <div className="preview">
                                                  <audio controls className="audioPlayer" id="audioPlayer">
                                                      <source id="audioSource" src={URL.createObjectURL(this.state.voiceNote)} type="audio/mpeg"/>
                                                      <source src={URL.createObjectURL(this.state.voiceNote)}  type="audio/ogg"></source>
                                                        Your browser does not support the audio element.
                                                  </audio>
                                                    <MDBIcon icon="trash" className="mr-2 removeImg2" style={{top:'20px'}}
                                                        onClick={() => this.removeFileVoiceNote()}></MDBIcon>
                                                </div>
                                                }
                                                </MDBCol>
                                            </MDBRow>
                                            <MDBRow>
                                                <MDBCol md="12">
                                                <label htmlFor="form8930" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.imgs}</label>

                                                    <div className="fileUpload2"> 
                                                        <input multiple key={this.state.imgs} type='file' className="upImgs2" onChange={this.fileChangedHandlerImgs} ></input>
                                                        <span className="uploadParent"><UploadOutlined style={{color: '#000',fontSize: '14px',position: 'relative',top: '-3px',marginRight: '2px'}}/><span className="uploadName">{allStrings.upload}</span></span>
                                                    </div>
                                                    <div className="preview">
                                                    {this.state.imgsPreviewUrl.map((val,i) => (
                                                    <div style={{display:"inline-block",width: '100%',border: '1px solid mediumaquamarine',marginBottom:'10px'}}>
                                                        <img crossorigin="anonymous"alt="" src={this.state.imgsType==="data"?val:val} className="previewImg2"/>
                                                        
                                                        <span className="imgName">{this.state.imgsName[i]}</span>
                                                        <MDBIcon icon="trash" className="mr-2 removeImg2" 
                                                        onClick={() => this.removeFileImgs(val)}  ></MDBIcon>
                                                    </div>
                                                    ))}
                                                    </div>
                                                    
                                                </MDBCol>
                                            </MDBRow>
                                            <MDBRow>
                                                <MDBCol md="12">
                                                <label for="form830" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.files}</label>
                                                    <div className="fileUpload2"> 
                                                        <input  key={this.state.pdf} type='file' className="upImgs2" onChange={this.fileChangedHandlerPdf} ></input>
                                                        <span className="uploadParent"><UploadOutlined style={{color: '#000',fontSize: '14px',position: 'relative',top: '-3px',marginRight: '2px'}}/><span className="uploadName">{allStrings.uploadFile}</span></span>
                                                    </div>
                                                    <div className="preview">
                                                        {this.state.pdfName&&
                                                        <div style={{ display: "inline-block" }}>
                                                        <p className="previewPdf">{this.state.pdfName}
                                                        <MDBIcon icon="times" className="mr-2 removePdf"
                                                            onClick={() => this.removePdf()}  ></MDBIcon>
                                                        </p>
                                                        </div>
                                                        }
                                                    </div>
                                                </MDBCol>
                                                
                                                <br></br>
                                                {this.state.pdf != null &&
                                                    <div>
                                                        <a href={this.state.pdf} target="blank" style={{background:'linear-gradient(135deg, #0F1A2C, #233B5B, #3A5278)',
                                                        color: '#fff',
                                                        padding: '3px 40px',
                                                        marginLeft: '15px'}}
                                                        >
                                                            {allStrings.openFile}          
                                                        </a>
                                                    </div>
                                                }
                                            </MDBRow>
                                        </div>
                                        <br></br>
                                        <br></br>
                                        <div className="text-center">
                                            <MDBBtn
                                            style={{background:'linear-gradient(135deg, #0F1A2C, #233B5B, #3A5278)',color:'#fff'}}
                                            rounded
                                            color="#233b5b"
                                            type="submit"
                                            disabled={this.state.showDialog?true:false}
                                            className="btn-block z-depth-1a"
                                            >
                                            <MDBIcon icon="plus" className="mr-2" />
                                                {allStrings.add}          
                                            </MDBBtn>
                                          
                                        </div>
                                    </form>
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                        </CardContent>
                    </Card>
                </div>
            </MDBCol>
            </MDBRow>
      </MDBContainer>
      
    </div> 
  )
  }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
  });
  
  const mapDispatchToProps = {
  };
  
  export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(AddSharedProperty)
  );